import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { makeUnscaledImageUrl } from '../cloudinary-image/helpers/make-image-url';
import { LinkBox, LinkOverlay } from '@hub/link';
export { default as getTopStripProps } from './get-top-strip-props';
export { default as useTopStripProps } from './use-top-strip-props';
export { default as useIsTopStripEnabled } from './use-is-top-strip-enabled';
import { Image } from '@hub/image';
import { jsx as _jsx } from "react/jsx-runtime";
const TopStrip = _ref => {
  let {
    backgroundImage,
    backgroundColour: backgroundColor,
    foregroundImage,
    shortDescription,
    actionText,
    url,
    backendTitle,
    onClick,
    sx
  } = _ref;
  return /*#__PURE__*/_jsx(LinkBox, {
    onClick: onClick,
    "data-id": "top-strip_index_TopStrip_LinkBox",
    children: /*#__PURE__*/_jsx(CoreContainer, {
      maxWidth: "size-full",
      gutter: [],
      "data-id": "top-strip_index_TopStrip_LinkBox_CoreContainer",
      children: /*#__PURE__*/_jsx(LinkOverlay, {
        href: url,
        sx: {
          display: 'block',
          backgroundColor,
          backgroundImage: backgroundImage ? makeUnscaledImageUrl(backgroundImage) : undefined,
          backgroundSize: 'auto var(--chakra-sizes-size-xs)',
          backgroundRepeat: 'repeat',
          backgroundPositionX: 'left'
        },
        title: actionText,
        "data-id": "top-strip_index_TopStrip_CoreContainer_LinkOverlay",
        children: /*#__PURE__*/_jsx(Image, {
          src: makeUnscaledImageUrl(foregroundImage),
          description: shortDescription,
          sx: _objectSpread({
            margin: '0 auto',
            height: isOlympics(backendTitle) ? 120 : 'var(--chakra-sizes-size-xs)'
          }, sx),
          "data-id": "top-strip_index_TopStrip_LinkOverlay_Image"
        })
      })
    })
  });
};
function isOlympics(backendTitle) {
  return backendTitle.toLowerCase().indexOf('olympics') > -1 || backendTitle.toLowerCase().indexOf('paralympics') > -1;
}
export default TopStrip;